module.exports = __webpack_public_path__ + "img/logo.da2cd273.svg";